package com.milta.core.localization.translations.ro

import com.milta.core.localization.PackageLabelScanStrings

internal val PackageLabelScan = PackageLabelScanStrings(
    scanTitle = "Scanați o etichetă",
    analysingTitle = "Se citește eticheta…",
    analysingSubtitle = "Căutăm numele, adresa și numărul de telefon al destinatarului. Durează doar câteva secunde.",
    reviewTitle = "Confirmați livrarea",
    deliveryDetectedLabel = "Livrare detectată",
    allReadableLabel = "Totul este lizibil",
    fieldToCompleteSingularSuffix = "câmp de completat",
    fieldToCompletePluralSuffix = "câmpuri de completat",
    recipientNotDetectedValue = "Nedetectat",
    addressNotDetectedValue = "Nedetectată",
    phoneNotDetectedValue = "Nedetectat",
    fieldRequiredWarning = "Câmp obligatoriu pentru a adăuga livrarea",
    recipientCorrectionPlaceholder = "Introduceți destinatarul…",
    addressCorrectionPlaceholder = "Introduceți adresa…",
    unreadableTitle = "Etichetă ilizibilă.",
    unreadableMessage = "Faceți o nouă fotografie cadrată pe etichetă, bine luminată și fără reflexii.",
    maxAttemptsMessage = "Completați această livrare manual, sau reluați scanarea cu o fotografie nouă.",
)
